import { Button } from "antd";
import React from "react";

interface SendRequestButtonProps {
  onClick: () => void;
}
const SendRequestButton = ({ onClick }: SendRequestButtonProps) => {
  return (
    <Button onClick={onClick} type="primary">
      Request This Service
    </Button>
  );
};

export default SendRequestButton;
